document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('[bundle-product__atc]').addEventListener('click', function(event) {
    event.preventDefault();

    const bundleProducts = [];

    document.querySelectorAll('.bundle-product__quantity').forEach(quantityField => {
      const quantity = parseInt(quantityField.value);
      const productId = quantityField.getAttribute('data-bundle-product-id');

      if (quantity >= 1) {
        bundleProducts.push({
          id: productId,
          quantity: quantity
        });
      }
    });

    if (bundleProducts.length > 0) {
      const data = { items: bundleProducts };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(response => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(() => {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const drawerInner = html.querySelector('.drawer__inner');

            const drawerInnerElement = document.querySelector('#CartDrawer .drawer__inner');
            const cartIconBubbleElement = document.querySelector('#cart-icon-bubble .cart-count-bubble');

            if (drawerInner && drawerInnerElement) {
              drawerInnerElement.innerHTML = drawerInner.innerHTML;
            } else {
              console.error('Drawer inner element not found');
            }

            if (cartIconBubbleElement) {
              const cartItemCount = document.querySelector('.drawer__header').getAttribute('data-cart-count');
              if (cartItemCount) {
                cartIconBubbleElement.innerHTML = cartItemCount;
              } else {
                console.error('Cart item count not found in response');
              }
            } else {
              console.error('Cart count bubble element not found');
            }

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              const cartItems = document.querySelectorAll('.cart-item');
              if (cartItems.length > 0) {
                cartDrawer.classList.remove('is-empty');
              }

              cartDrawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            }
          })
          .catch((e) => {
            console.error("Error updating the cart drawer:", e);
          });
      })
      .catch(async error => {
        const errorMsg = (await error.json()).description;
        alert(`Error: ${errorMsg}. Try Again...`);
      });
    } else {
      alert("Please select at least one product.");
    }
  });
});
